import { onUnmounted, ref } from 'vue'

import { useLoggerStore } from '@/store/logger'
import { type AvailablePGEvents, GAMEPLAY_EVENT_THRESHOLDS_MS } from '@/types/logger.types'

const SECOND = 1000
const MINUTE = 60_000
const TICK = SECOND

interface ThresholdConfig {
    thresholdMs: number
    fired: boolean
    eventName: AvailablePGEvents
}

export const useGameAnalyticsEvents = () => {
    const loggerStore = useLoggerStore()
    const intervalRef = ref<ReturnType<typeof setInterval>>()
    const ticks = ref(0)
    const fired = ref(false)

    // used for old business logic, but maybe useful in future
    const _mainCategoryForDetection = ref<string>()

    const eventsConfig = ref<ThresholdConfig[]>([
        { thresholdMs: 3 * MINUTE, fired: false, eventName: 'playgame_3min' },
        { thresholdMs: 5 * MINUTE, fired: false, eventName: 'playgame_5min' },
        { thresholdMs: 10 * MINUTE, fired: false, eventName: 'playgame_10min' },

        { thresholdMs: GAMEPLAY_EVENT_THRESHOLDS_MS.game, fired: false, eventName: 'game' },
        { thresholdMs: 15 * SECOND, fired: false, eventName: 'game_15s' },
        { thresholdMs: GAMEPLAY_EVENT_THRESHOLDS_MS.game_30s, fired: false, eventName: 'game_30s' },
        { thresholdMs: GAMEPLAY_EVENT_THRESHOLDS_MS.game_60s, fired: false, eventName: 'game_60s' },

        // game_timespent_ltv event is sending multiple times with different timeouts
        { thresholdMs: 5 * MINUTE, fired: false, eventName: 'timespent_ltv' },
        { thresholdMs: 11 * MINUTE, fired: false, eventName: 'timespent_ltv' },
        { thresholdMs: 18 * MINUTE, fired: false, eventName: 'timespent_ltv' },
        { thresholdMs: 26 * MINUTE, fired: false, eventName: 'timespent_ltv' },
        { thresholdMs: 35 * MINUTE, fired: false, eventName: 'timespent_ltv' },
        { thresholdMs: 50 * MINUTE, fired: false, eventName: 'timespent_ltv' },
    ])

    const intervalTick = () => {
        if (document.hidden) {
            return
        }
        ticks.value += TICK
        for (const t of eventsConfig.value) {
            if (!t.fired && ticks.value >= t.thresholdMs) {
                t.fired = true
                loggerStore.logEvent({
                    event: 'custom_event',
                    eventName: t.eventName,
                })
            }
        }
    }

    const startTimers = (mainCategory?: string) => {
        _mainCategoryForDetection.value = mainCategory
        if (fired.value) {
            return
        }
        ticks.value = 0
        clearInterval(intervalRef.value)
        intervalRef.value = setInterval(intervalTick, TICK)
        intervalTick()
    }

    onUnmounted(() => {
        clearInterval(intervalRef.value)
    })

    return {
        startTimers,
    }
}
